export default __webpack_public_path__ + "static/media/vrbg.44e69599.svg";